// extracted by mini-css-extract-plugin
export default {"testimonialWrapper":"testimonials_testimonialWrapper__cBB5b","heading":"testimonials_heading__l9w1y","paratext":"testimonials_paratext__fj6jJ"};